<template>
    <kiosk-layout>
        <template v-if="!loading" v-slot:subtitle>
            <a href="/kiosk/migrations" class="no-underline! text-sky-600! text-base font-normal">
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                Back to Migrations
            </a>
        </template>
        <template v-if="!loading" v-slot:title>Migration {{ migration.id }}</template>
        <template v-if="!loading" v-slot:sidebar>
            <page-sidebar :links="navigationLinks"></page-sidebar>
        </template>

        <page-loading v-if="loading"></page-loading>
        <slot v-else></slot>
    </kiosk-layout>
</template>

<script setup>
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted, computed } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { useMigrationDetails } from '../composables/useMigrationDetails';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';

const props = defineProps({
    migrationId: {
        type: Number,
        required: true,
    },
});

const { mount, migration, loading } = useMigrationDetails();

const navigationLinks = computed(() => [
    { href: `/kiosk/migrations/${props.migrationId}`, label: 'Details' },
    { href: `/kiosk/migrations/${props.migrationId}/config`, label: 'Config' },
]);

onMounted(() => {
    mount(props.migrationId);
});
</script>
